import ExtensionEventsService from '@peekops/peek-extensions-framework/services/extensions/extension-events'

/**
 * example event subscription for Ember:
 *
 * 1- Inject service on ember side:
 * @service('extensions/extension-events') extensionEvents
 *
 * 2- Subscribe to event on ember side
 * this.extensionEvents.subscribeToExtensionEvent('SHOULD-MATCH', (message: unknown, data: unknown) => {
 *   console.log(this, message, data)
 * })
 *
 * 3- Send event from extension
 * this.dispatchEventToPeek({
 *         eventName: 'SHOULD-MATCH', // this event name should match on the ember side
 *         data: { message: 'This event comes from extension code!' }
 *       })
 */
export default class CustomerFlowsExtensionEventsService extends ExtensionEventsService {
}
